import React from "react";

const Spinner: React.FC = () => (
  <div className="fixed inset-0 flex items-center justify-center bg-black/30 z-50">
    <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
  </div>
);

export default Spinner;
